// src/components/Portfolio.js
import React from 'react';

function Portfolio() {
  // Array matching the image names and the original text descriptions
  const portfolioItems = [
    { id: 1, text: 'Bedrucktes Hochzeit T-shirt', imageName: 'IMG-20240616-WA0007.jpg' },
    { id: 2, text: 'Bedrucktes Hochzeitsoutfit Frau', imageName: 'IMG-20240616-WA0008.jpg' },
    { id: 3, text: 'Lustiges T-shirt', imageName: 'IMG-20240616-WA0009.jpg' },
    { id: 4, text: 'Individuell bedruckte Tasse mit Namen', imageName: 'IMG-20240616-WA0010.jpg' },
    { id: 5, text: 'Bedruckte Verein Textilie', imageName: 'IMG-20240616-WA0011.jpg' },
    { id: 6, text: 'Bedrucktes Verein T-shirt', imageName: 'IMG-20240616-WA0012.jpg' },
    { id: 7, text: 'Bedruckter Verein Pullover', imageName: 'IMG-20240616-WA0013.jpg' },
    { id: 8, text: 'Bedruckte Uhr mit Starwars Logo', imageName: 'IMG-20240616-WA0014.jpg' },
    // Add more items here if you have more images
  ];

  return (
    <section id="portfolio" className="section portfolio-section">
      <div className="container">
        {/* Make sure H2 has the class if you want the tape animation */}
        <h2 className="section-title-animated">Resultate</h2>
        <div className="portfolio-grid">
          {portfolioItems.map((item) => (
            <div
              key={item.id}
              className="portfolio-item"
              data-caption={item.text} // For CSS hover effect
            >
              <img
                // Use PUBLIC_URL for reliable asset path in builds
                src={`${process.env.PUBLIC_URL}/images/${item.imageName}`}
                alt={item.text}
                className="portfolio-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Portfolio;